import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  Input, OnChanges,
  OnInit, SimpleChanges
} from '@angular/core';

import {delay} from 'rxjs/operators'
import {isEmpty} from "lodash";
import {tooltipPositions} from "../../../../shared/directives/tooltips/tooltip.directive";
import {DropDownMenuItem} from "@ispm/dashboard/menu/components/drop-down-menu/drop-down-menu.interface";
import {PermissionSchemaRestrictComponent} from "@ispm/shared/directives/permission-schema/permission-schema-restrict.component";
import {Observable} from "rxjs";
import { AuthenticationService } from '@ispm/user/services/authentication.service';

@Component({
  selector: 'drop-down-menu',
  templateUrl: './drop-down-menu.component.html',
  styleUrls: ['./drop-down-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DropDownMenuComponent implements OnInit, OnChanges {

  @Input()
  public menuClassName: string;

  @Input()
  public tooltipHtml: string;

  @Input()
  public tooltipPosition: tooltipPositions = tooltipPositions.BOTTOM;

  @Input()
  public menuItems: Array<DropDownMenuItem>;
  public filteredMenuItems: Array<DropDownMenuItem>;

  @Input()
  public disabled: boolean = false;

  @Input()
  public permissionId: string;

  constructor(private authService: AuthenticationService) {
  }

  public menuItemsVisibility: boolean = false;

  ngOnInit() {
  }

  private initMenuItems() {
    // build list of relevant actions
    if (!this.menuItems || this.menuItems.length == 0) {
      this.filteredMenuItems = [];
    } else {
      this.filteredMenuItems = this.menuItems.filter((action => {

        // ignore disabled actions
        if (action.enable === false) {
          return false;
        }

        // ignore action if user is not permitted to it by the given permissionId
        if (this.isForcePermission(action.permissionId) &&
            !this.authService.doesUserHasPermission(action.permissionId)) {

          console.debug('user is missing permission to run action: ' + action.label);
          return false;
        }

        return true;
      }));
    }
  }

  async runMenuItemAction(menuItem: DropDownMenuItem) {
    menuItem.action(menuItem['payload']);
    this.showMenuItems(false);
  }

  runTopMenuAction() {
    this.showMenuItems(true);

    // if there is only 1 current action, run it automatically
    // Code commented as part of the User story : GEN-88554
    // The action should not be auto selected if theres only one item
    // in drop down
    /*if (this.filteredMenuItems.length == 1) {

      // show for a brief time the single menu-item and activate it
      Observable.of(null)
        .pipe(delay(50))
        .subscribe(object => this.runMenuItemAction(this.filteredMenuItems[0]));

    }*/

  }

  showMenuItems(visible?: any) {

    if (visible === undefined) {
      this.menuItemsVisibility = !this.menuItemsVisibility;
    } else {
      this.menuItemsVisibility = visible;
    }

  }

  getNoPermissionAction(): string {
    return PermissionSchemaRestrictComponent.actionHide;
  }

  isForcePermission(permissionId: string) : boolean {
    return ! isEmpty(permissionId);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.menuItems){
      this.initMenuItems();
    }
  }
}


